import { render, staticRenderFns } from "./RoomInformation.vue?vue&type=template&id=ff97c40a&scoped=true"
import script from "./RoomInformation.vue?vue&type=script&lang=js"
export * from "./RoomInformation.vue?vue&type=script&lang=js"
import style0 from "./RoomInformation.vue?vue&type=style&index=0&id=ff97c40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff97c40a",
  null
  
)

export default component.exports